<template>
  <v-navigation-drawer
    style="z-index:9999999"
    :value="drawer"
    right
    fixed
    @input="updateDrawerFromClose"
  >
    <v-list-item class="mt-12">
      <v-list-item-content>
        <v-list-item-title
          :class="
            $vuetify.theme.isDark
              ? 'white--text  font-weight-bold title'
              : 'primary--text  font-weight-bold title'
          "
        >
          Variables
        </v-list-item-title>
        <v-list-item-subtitle
          v-if="equipmentProfile && equipmentProfile.equipTag"
        >
          {{ equipmentProfile.equipTag }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>
    <v-list dense rounded nav>
      <v-list-item-group
        active-class="border"
        :color="$vuetify.theme.isDark ? 'white' : 'primary'"
        :v-model="currentItem"
      >
        <v-list-item
          @click="$emit('set-item', grupo)"
          v-for="grupo in grupos"
          :key="grupo.name"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{
                grupo.tagName ? grupo.tagName : $t(`variables.${grupo.name}`)
              }}
              <span v-if="grupo.tagName" class="text-caption">
                {{ $t(`variables.${grupo.name}`) }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    },
    grupos: {
      type: Array,
      default: () => []
    },
    equipmentProfile: {
      type: Object,
      default: () => {}
    },
    drawer: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateDrawerFromClose(payload) {
      this.$emit("update-drawer", payload);
    }
  },
  data() {
    return {
      items: [
        { title: "Home", icon: "mdi-view-dashboard" },
        { title: "About", icon: "mdi-forum" }
      ]
    };
  }
};
</script>
